import { createTheme, responsiveFontSizes } from '@mui/material/styles';


let theme = createTheme({
  palette: {
    primary: {
      main: '#723989',
    },
    secondary: {
      main: '#ee9338'
    }
  },
  
})

theme = responsiveFontSizes(theme);

export { theme }


